export const formatNumber = (value) => {
    const num = Number(value);

    if (!Number.isFinite(num)) return "0";

    return num.toLocaleString("en-IN");
};

export const formatKeysToLabel = (key) => {
    return key
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase());
}